import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@babackapp/customer-ui/components/alert";
import { Button } from "@babackapp/customer-ui/components/button";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import type {
  ReturnRequestShippingInfoDto,
  ReturnRequestStatusDto,
} from "@babackapp/private-api-client";
import { Download, MapPin } from "lucide-react";
import { motion } from "motion/react";
import { resolveAlertConfig } from "../../utils/resolve-alert-config";

type Props = {
  status: ReturnRequestStatusDto;
  shippingInfo: ReturnRequestShippingInfoDto;
  relayUrl?: string | null;
};

export function StatusAlert({ status, shippingInfo, relayUrl }: Props) {
  const t = useCustomText();
  const config = resolveAlertConfig(status);

  if (!config) return null;

  const labelUrl = shippingInfo.label_url || null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Alert variant={config.variant}>
        {config.icon}
        <AlertTitle>{t(config.titleKey)}</AlertTitle>
        <AlertDescription className="flex flex-col items-start gap-3">
          <span>{t(config.descriptionKey)}</span>
          {labelUrl && (
            <a href={labelUrl} target="_blank" rel="noopener noreferrer">
              <Button variant="outline" size="sm" className="text-foreground">
                <Download />
                {t("endProcess.carrier.downloadLabel")}
              </Button>
            </a>
          )}
          {relayUrl && (
            <a href={relayUrl} target="_blank" rel="noopener noreferrer">
              <Button variant="link" size="sm" className="h-auto p-0">
                <MapPin />
                {t("endProcess.findRelay")}
              </Button>
            </a>
          )}
        </AlertDescription>
      </Alert>
    </motion.div>
  );
}
